import instance from '@/utils/axios';

/**
 * 获取设备版本信息
 * @param {string} sn - 设备序列号
 * @returns {Promise<{code: number, data: Object, message: string}>} 返回接口标准数据结构
 */
export function getDeviceUpgradeParams(sn) {
  return instance.get('/deviceUpgrade/getDeviceUpgrade', { params: { sn } });
}

/**
 * 设备升级
 * @param {string} sn - 设备序列号
 * @returns {Promise<{code: number, data: Object, message: string}>} 返回接口标准数据结构
 */
export function upgradeDevice(sn) {
  return instance.get('/deviceUpgrade/upgrade', { params: { sn } });
}
